
import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import TreeView from '@/views/Project/Observation/components/treeViewInfo.vue'

import { observationIcons } from '@/types/observation'

@Component({
    mixins: [ObservationMixin],
    components: { TreeView },
    inheritAttrs: false,
})
export default class TreeviewChip extends Mixins<MixinInterface>(ObservationMixin) {
    @Prop({ default: null }) item!: any
    @Prop({ required: true }) items!: Array<any>
    @Prop() itemType!: string

    get observationIcons() {
        return observationIcons
    }
}
